import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { BOX_SHADOW, BREAKPOINTS, COLORS, FONT_SIZE, FONT_WEIGHT } from '@/constants';
import Icon from '@/components/icons';
import { SmallStyles } from '@/components/type';

const ICON_SIZES = `
  width: 34px;
  height: 34px;

  @media (min-width: ${BREAKPOINTS.LG}px) {
    width: 44px;
    height: 44px;
  }`;

const WrapperStyles = css`
  display: flex;
  flex-direction: row;
  border-radius: 0;
  height: 100%;
  background-color: ${COLORS.WHITE};
  -webkit-tap-highlight-color: transparent;
  width: 100%;
`;

const Wrapper = styled.div`
  ${WrapperStyles};
  border: 1px solid ${COLORS.GREY_FOUR};
`;

const WrapperLinked = styled.a`
  ${WrapperStyles};
  box-shadow: ${BOX_SHADOW.DEFAULT};

  :hover {
    cursor: pointer;
    box-shadow: ${BOX_SHADOW.HOVER};
  }
`;

const InnerWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
`;

const StyledIcon = styled.img`
  border-radius: 10px;
  ${ICON_SIZES};
`;

const FallbackIcon = styled(Icon)`
  ${ICON_SIZES};
`;

const DetailLink = styled.span`
  ${SmallStyles}
  color: ${COLORS.BRAND_BLUE_EIGHT};
  font-weight: ${FONT_WEIGHT.BOLD};
  text-decoration: none;
  user-select: none;

  &:hover {
    text-decoration: underline;
  }
`;

const RightColumnWrapper = styled.div`
  flex-direction: column;
  display: flex;
  height: 100%;
`;

const StyledStatusLabel = styled.span`
  color: ${({ color }) => color};
  font-weight: ${FONT_WEIGHT.BOLD};

  font-size: ${FONT_SIZE.XX_SMALL};
  line-height: 16px;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    font-size: ${FONT_SIZE.SMALL};
    line-height: 18px;
  }
`;

const StatusIconWrapper = styled.div`
  display: inline-flex;
`;

export {
  DetailLink,
  StyledIcon,
  RightColumnWrapper,
  StyledStatusLabel,
  Wrapper,
  WrapperLinked,
  InnerWrapper,
  FallbackIcon,
  StatusIconWrapper,
};
